<template>
    <div>
        <ul class="titlemenu-phone">
            <li v-for="(menu,index) in menuarray" :key="index" :class="pid == menu.id ? 'active' : '' ">
                <a href="javascript:void(0)" @click="clickfunc(menu)">{{menu.title}}</a> <span>|</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  props: ["menuarray","pid"],
  methods:{
      clickfunc:function(menu){
          this.$emit('gotoinfo',menu);
      }
  }
};
</script>

<style>
.titlemenu-phone li.active a {font-size: 14px;
    background-color: white;
    color: #083286;
    font-weight: bold;}
</style>